import Vue2 from 'vue/dist/vue.common.js'
import Raven from 'raven-js'
import RavenVue from 'raven-js/plugins/vue'

if(process.env.MIX_SENTRY_DSN) {
  Raven.config(process.env.MIX_SENTRY_DSN, {
    shouldSendCallback: () => process.env.NODE_ENV !== 'development',
  }).addPlugin(RavenVue, Vue2)
    .install()
}